export const notificationsUserRoutes = [
  {
    path: 'listing/:reference_number',
    name: 'notifications-user',
    component: () => import(/* webpackChunkName: "notifications-user" */ './NotificationsUser.vue')
  }
];
